module.exports = __webpack_public_path__ + "img/money_s.016c0142.svg";